var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 57,
    viewBox: "0 0 173 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.465 6.756c-.638-.848-1.452-1.67-2.172-2.503-2.137-2.488-7.7-3.159-12.682-3.574-3.946-.32-8.208-.168-12.189-.183-3.133-.011-6.205.094-9.326.176-5.64.171-11.358-.116-17.001-.182-4.842-.045-9.647-.461-14.477-.479A1314 1314 0 0 0 82.433.06c-9.108.132-18.097.504-27.172.47C42.912.484 18.922-1.176 8.342 1.966A35 35 0 0 0 4.7 3.254c-2.163.913-2.897 2.437-3.2 3.786-2.638 12.034-1.447 27.707.844 39.796.732 3.827 5.94 7.063 15.895 8.247 12.555 1.493 28.173.974 40.857.635 8.023-.182 16.302.174 24.376.15a854 854 0 0 0 32.831-.787c8.021-.353 16.046-.034 24.012.478 9.849.649 23.339.406 29.033-4.195 5.325-4.318 3.347-39.27-.883-44.608",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/button.889c6f3f90b71faf26281d8218adb273.svg";
export { ForwardRef as ReactComponent };